const murUsageItemData = [
    {
        blocTitle: 'Je sélectionne ma couverture de toiture',
        blocContent: [
            {
                imageUrl : '/assets/images/Terrace-extérieure.png',
                title: 'BRIQUE/PARPAING',
                // description: 'Terrace extérieure',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'BÉTON',
                // description: 'Bardages extérieur',
            },
            {
                imageUrl : '/assets/images/Lambri-intérieur.png',
                title: 'PIERRE',
                // description: 'Lambris intérieure',
            },
            {
                imageUrl : '/assets/images/Parquet-intérieur.png',
                title: 'PLAQUE BAC ACIER',
                description: 'Type Tôle Acier',
            },
        ],
        isBlockA: true,
        hasInput: true,
        inputLabel: 'Quelle épaisseur ?',
        inputDescription: 'Cette information permet de définir les fixations et impacte les calculs.',
    },
    {
        blocTitle: 'Je sélectionne l\'usage de mon batiment',
        blocContent: [
            {
                title: 'HABITATION',
            },
            {
                title: 'GARAGE/GRANGE',
            },
            {
                title: 'AUTRE',
            }
        ],
        isBlockA: false,
        hasInput: true,
        inputLabel: 'Si AUTRE : Quel Usage ?',
        inputDescription: '',
    }
]

export default murUsageItemData;